import FormClientStore from "@/Components/View/FormClientStore/FormClientStore";
import PurcharsSummary from "@/Components/View/PurcharseSummary/PurcharsSummary";
import { useContextTicketProvider } from "@/Context/Ticket/ContextTicketCartProvider";
import { useTicketCart } from "@/Hooks/TicketCart/useTicketCart";
import useWindowsSize from "@/Hooks/useWindowsSize";
import { getIpCliente, useDeleteOrderBuy } from "@/Service/Api/Index";
import React, { lazy, Suspense, useCallback, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const LayoutHomeThree = lazy(
  () => import("@/Layout/HomeThree/LayoutHomeThree")
);

const stylesd: React.CSSProperties = {
  maxWidth: "233px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const PageFinishBuy = (): JSX.Element => {
  const { width } = useWindowsSize();
  const [sendBuy, setSendBuy] = useState<boolean>(false);
  const navigate = useNavigate();

  /*********** basket si se realizo se eliminara ************/
  const { ResponseBasket } = useContextTicketProvider();
  const { addTicketProduct } = useTicketCart();
  const { deleteData, eliminarOrderBuySku } = useDeleteOrderBuy(
    addTicketProduct[0]?.item_id ?? ""
  );

  /*********** ENVIO DE DATOS  ****************/
  const HeaddleSendBuy = (sendBuyAc: boolean) => setSendBuy(sendBuyAc);

  useEffect(() => {
    if (!sendBuy) {
      navigate(
        `/Electrónicav2/articles/c/Checkout/FinshBuy?viewCart=parcharsebuy.html`
      );
    }
  }, [sendBuy]);

  const headdlesDeleteOrderBuy = useCallback(async () => {
    //console.log("Eliminar el basket id del carrito");
    if (
      ResponseBasket?.basketId !== "" ||
      ResponseBasket?.basketId !== undefined
    ) {
      const ipClient = await getIpCliente();
      const deleteBuyOrder = {
        basketId: ResponseBasket?.basketId,
        skuId:
          addTicketProduct
            .flatMap((x) => x.item_id)
            .filter(Boolean)
            .join(",") ?? "",
        ipAddress: ipClient,
      };
      //ENVIAMOS HACIA EL BACK PARA ELIMINAR DESDE CACHE Y LIMPIAR LO DATOS GUARDADOS
      await deleteData(eliminarOrderBuySku, deleteBuyOrder);
    }
    HeaddleSendBuy(false);
  }, []);

  return (
    <Suspense>
      <LayoutHomeThree toLink={"/Electrónicav2"} PLP={false}>
        <div className="ps-page--simple">
          <div className="ps-breadcrumb">
            <div className="container">
              <ul className="breadcrumb">
                <li>
                  <Link to="/" onClick={headdlesDeleteOrderBuy}>
                    Inicio
                  </Link>
                </li>
                <li>
                  <Link to="/Electrónicav2" onClick={headdlesDeleteOrderBuy}>
                    Electronica
                  </Link>
                </li>
                <span style={width < 540 ? stylesd : {}}>
                  {" "}
                  /{" "}
                  <Link
                    to="/Electrónicav2/articles/c/Checkout/Buy?BuyCart=MyCart.html"
                    onClick={headdlesDeleteOrderBuy}>
                    Carrito de Compara
                  </Link>
                </span>
                <li style={width < 540 ? stylesd : {}}>
                  {!sendBuy ? "Resumen de Compara" : "Método de entrega"}
                </li>
              </ul>
            </div>
          </div>
          <div className="ps-shopping-cart">
            <div className="container">
              <div className="ps-section__header p-4 d-flex justify-content-center">
                {width > 1200 ? (
                  <h2 className="develop___text">Carrito de compra</h2>
                ) : (
                  <h3 className="develop___text">Carrito de compra</h3>
                )}
              </div>
              <div className="ps-section__content">
                <div className="d-flex justify-content-center">
                  {!sendBuy ? (
                    <PurcharsSummary HeaddleSendBuy={HeaddleSendBuy} />
                  ) : (
                    <FormClientStore />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutHomeThree>
    </Suspense>
  );
};

export default PageFinishBuy;
